import { Navigate, Route, Routes } from 'react-router-dom'
import { PublicLayout } from './components/layout/PublicLayout'
import { AppLayout } from './components/layout/AppLayout'
import { Landing } from './pages/Landing'
import { SignIn } from './pages/SignIn'
import { NotFound, Placeholder } from './pages/Placeholder'
import { Overview } from './pages/app/Overview'
import { ServiceAreas } from './pages/app/ServiceAreas'

export function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<Landing />} />
        <Route path="sign-in" element={<SignIn />} />
        <Route
          path="how-it-works"
          element={
            <Placeholder
              title="How it works"
              planned="A walkthrough of a season: the unit sets its area and schedule, neighbors subscribe and pay, Scouts get routes, flags go out and come back."
            />
          }
        />
        <Route
          path="for-units"
          element={
            <Placeholder
              title="For units"
              planned="Request access for your unit. A Site Admin reviews the request before the unit can start selling."
            />
          }
        />
        <Route
          path="account"
          element={
            <Placeholder
              title="My account"
              planned="Customer portal. Enter your email to get a sign-in link, then view your subscription, update placement notes, and message your unit."
            />
          }
        />
        <Route
          path="signup/:unitSlug"
          element={
            <Placeholder
              title="Sign up for flag service"
              planned="Name, email with verification, phone, and service address. The address is geocoded on the server and checked against the unit's service area before an invoice is issued."
            />
          }
        />
        <Route
          path="contact"
          element={
            <Placeholder
              title="Contact"
              planned="Start a message thread with your unit, or with the site if you are a Unit Admin. Replies can arrive by email and answering that email posts back to the thread."
            />
          }
        />
        <Route
          path="privacy"
          element={<Placeholder title="Privacy" planned="What the site stores and why." />}
        />
      </Route>

      <Route path="app" element={<AppLayout />}>
        <Route index element={<Overview />} />
        <Route path="service-areas" element={<ServiceAreas />} />
        <Route
          path="subscriptions"
          element={
            <Placeholder
              title="Subscriptions"
              planned="This season's signups, their payment state, and the flag count for each address."
            />
          }
        />
        <Route
          path="routes"
          element={
            <Placeholder
              title="Routes"
              planned="Group addresses into routes, assign Scouts, and publish. Publishing emails each Scout their own address list."
            />
          }
        />
        <Route
          path="scouts"
          element={
            <Placeholder
              title="Scouts"
              planned="Invite, deactivate, and remove Scouts and fellow Unit Admins. Deactivating keeps their history."
            />
          }
        />
        <Route
          path="holidays"
          element={
            <Placeholder
              title="Holidays"
              planned="Your unit's holiday list, seeded from the standard set. Add local observances or drop ones you do not serve."
            />
          }
        />
        <Route
          path="messages"
          element={
            <Placeholder
              title="Messages"
              planned="Customer threads for your unit, and your own threads with the site admins."
            />
          }
        />
        <Route
          path="site"
          element={
            <Placeholder
              title="Site admin"
              planned="Approve and suspend units, and maintain the global default holiday set."
            />
          }
        />
      </Route>

      {/* Old bookmark shape, kept pointing somewhere useful. */}
      <Route path="dashboard" element={<Navigate to="/app" replace />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
